
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"43","height":"43","viewBox":"0 0 43 43","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"opacity":".3","x":".868","y":".481","width":"42","height":"42","rx":"6","fill":"#B2D4D1"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M10 15.69c0-.381.344-.69.77-.69h21.46c.426 0 .77.309.77.69 0 .381-.344.69-.77.69H10.77c-.426 0-.77-.309-.77-.69zm14.711 3.6a.845.845 0 01.788.03l7.153 4.206a.675.675 0 01.348.577c0 .233-.13.45-.348.577L25.5 28.887a.845.845 0 01-.788.03.684.684 0 01-.403-.607v-8.413c0-.254.155-.487.403-.607zM10 19.896c0-.381.344-.69.77-.69h9.538c.425 0 .769.309.769.69 0 .38-.345.69-.77.69H10.77c-.425 0-.769-.31-.769-.69zm15.846 1.277v5.858l4.982-2.929-4.982-2.929zM10 24.104c0-.382.344-.69.77-.69h7.153c.425 0 .77.308.77.69 0 .38-.345.69-.77.69H10.77c-.425 0-.769-.31-.769-.69zm0 4.206c0-.381.344-.69.77-.69h3.576c.425 0 .77.309.77.69 0 .381-.345.69-.77.69H10.77c-.425 0-.769-.309-.769-.69z","fill":"#65AAA3"}})])
          )
        }
      }
    